import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Icon } from "@iconify/react";
import toast from "react-hot-toast";
import { useAuth } from "../../hooks/useAuth";
import { cloudfish, login_image } from "../../Assets";
import { login_user_api } from "../../DAL/Users";

const LoginPage = () => {
  const navigate = useNavigate();
  const { setUserInfo, userInfo } = useAuth();
  const [passwordType, setPasswordType] = useState("password");
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const handleChangeIcon = () => {
    let password_type = "password";
    if (passwordType === "password") {
      password_type = "text";
    }
    setPasswordType(password_type);
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    if (errors[name]) setErrors((prev) => ({ ...prev, [name]: null }));
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      newErrors.email = "Please enter a valid email";
    }

    if (!formData.password.trim()) {
      newErrors.password = "Password is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    setIsLoading(true);
    const postData = { ...formData, role: "partner" };

    const result = await login_user_api(postData);
    if (result.code === 200) {
      const login_data = result.data;
      localStorage.setItem("token", login_data.access_token);
      localStorage.setItem("user_info", JSON.stringify(login_data.user));
      setUserInfo(login_data.user);
      navigate(`/home`);
    } else {
      toast.error(`${result.message}`);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (localStorage.getItem("token")) navigate(`/home`);
  }, [navigate]);

  return (
    <div className="login_page">
      <div className="d-lg-flex">
        <div className="login-container container">
          <div className="login-card">
            <div className="login-header">
              <div className="logo-box mb-3">
                <img src={cloudfish} alt="App Logo" className="login-logo" />
              </div>
              <h1>Enterprise Partners Portal</h1>
              <h5>Sign in to your account</h5>
            </div>

            <form onSubmit={handleSubmit}>
              {/* Email */}
              <div className="form-group">
                <label htmlFor="email">Email</label>
                <div className="input-wrapper">
                  {/* <Icon icon="mdi:email-outline" className="input-icon" /> */}
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="Enter your email"
                    className={`ps-3 ${errors.email ? "has-error" : ""}`}
                  />
                </div>
                {errors.email && (
                  <span className="error-message">
                    <Icon icon="mdi:alert-circle" className="error-icon" />
                    {errors.email}
                  </span>
                )}
              </div>

              {/* Password */}
              <div className="form-group mt-2">
                <label htmlFor="password">Password</label>
                <div className="input-wrapper">
                  <Icon
                    icon={`mdi:eye${passwordType === "password" ? "-off" : ""}`}
                    className="eye-icon"
                    onClick={handleChangeIcon}
                  />
                  <input
                    type={passwordType}
                    id="password"
                    name="password"
                    value={formData.password}
                    onChange={handleChange}
                    placeholder="Enter your password"
                    className={`ps-3 ${errors.email ? "has-error" : ""}`}
                  />
                </div>
                {errors.password && (
                  <span className="error-message">
                    <Icon icon="mdi:alert-circle" className="error-icon" />
                    {errors.password}
                  </span>
                )}
              </div>
              <div className="forget-password mt-2">
                <span className="login-forget-password">Forget password?</span>
              </div>

              {/* Submit */}
              <div className="login-button">
                <button
                  type="submit"
                  className="theme-button mt-2 w-100"
                  disabled={isLoading}
                >
                  {isLoading ? (
                    <>
                      <Icon icon="mdi:loading" className="spin" />
                      Logging in...
                    </>
                  ) : (
                    <>Sign in</>
                  )}
                </button>
              </div>
            </form>
            <hr className="login-border-line" />
            <div className="bottom-content">
              <div className="content-left">
                <div>HIPPA Compliant</div>
              </div>
              <div className="content-right">
                <div>Enterprise goate Security</div>
              </div>
            </div>
          </div>
        </div>
        {/* <div className="flex-1">
          <div
            className="login-image-container"
            style={{
              backgroundImage: `url(${login_image})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              height: "100vh",
            }}
          ></div>
        </div> */}
      </div>
    </div>
  );
};

export default LoginPage;
